import { FC } from 'react';
import { CommPreferencesView } from '../views/comm-preferences/comm-preferences';
import { FeedbackView } from '../views/feedback/feedback';
import { FormsView } from '../views/forms/forms';
import { NotesView } from '../views/notes/notes';
import { OverviewView } from '../views/overview/overview';
import { PatientFilesView } from '../views/patient-files/patient-files';
import { ScheduledCommsView } from '../views/scheduled-comms/scheduled-comms';
import { TreatmentPlansView } from '../views/treatment-plans/treatment-plans';
import { VisitsView } from '../views/visits/visits';

export enum PatientProfileRoutePath {
  OVERVIEW = '/overview',
  FORMS = '/forms',
  COMM_PREFENCES = '/comm-preferences',
  PATIENT_FILES = '/patient-files',
  NOTES = '/notes',
  MORE = '/more',
  SCHEDULED_COMMS = '/scheduled-comms',
  VISITS = '/visits',
  TREATMENT_PLANS = '/treatment-plans',
  FEEDBACK = '/feedback'
}

export type RouteConfigItem = { path: PatientProfileRoutePath; name: string; component: FC };

export const RouteConfig: RouteConfigItem[] = [
  { path: PatientProfileRoutePath.OVERVIEW, component: OverviewView, name: 'Overview' },
  { path: PatientProfileRoutePath.FORMS, component: FormsView, name: 'Forms' },
  { path: PatientProfileRoutePath.COMM_PREFENCES, component: CommPreferencesView, name: 'Comm Preferences' },
  { path: PatientProfileRoutePath.PATIENT_FILES, component: PatientFilesView, name: 'Patient Files' },
  { path: PatientProfileRoutePath.NOTES, component: NotesView, name: 'Notes' },
  { path: PatientProfileRoutePath.SCHEDULED_COMMS, component: ScheduledCommsView, name: 'Scheduled Comms' },
  { path: PatientProfileRoutePath.VISITS, component: VisitsView, name: 'Visits' },
  { path: PatientProfileRoutePath.TREATMENT_PLANS, component: TreatmentPlansView, name: 'Treatment Plans' },
  { path: PatientProfileRoutePath.FEEDBACK, component: FeedbackView, name: 'Feedback' },
];
